import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {Layout} from 'antd';

import NavBar from './template/navbar';
import LandingPage from './homepage';
import LoginPage from './login/loginPage';
import SignUpPage from './signup/signupPage';
import OnBoardingFlowPage from './onboarding-flow';
import OnBoardingFlowStep from './onboarding-flow/onboarding-flow-step';
import NotFoundPage from './pages/notFoundPage';
import AdminDashboardPage from './admin/brand-approval-page';
import ProfilePage from './creatives/profile/ProfilePage';
import Footer from './template/footer/index';
import RequireAuth from './auth/require_auth';
import PrivateRoute from './auth/PrivateRoute';
import ChooseSignup from './signup/chooseSignup';
import signupBrand from './signup/signupBrand';
import ChooseLoginPage from './login/chooseLogin';
import BrandLoginPage from './login/brandLogin';
import Home from './creatives/home/Home';
import StartDiscovery from '../components/brand/discovery/startDiscovery';
import BrandFlowPage from './brand/discovery/DiscoveryWizard';
import DiscoverySteps from './brand/discovery/DiscoverySteps';
import brandProfile from './brand/profile/brandProfile';
import BrandHome from './brand/home/brandHome';
import JobsPage from './jobs/JobsPage';

class Index extends Component {
  render() {
    return (
      <Layout
        style={{
          alignItems: 'flex-start',
          width: '100%',
          maxWidth: '100vw',
          background: 'transparent',
          margin: 0,
          padding: 0,
        }}
      >
        <Layout.Content
          style={{
            margin: 0,
            width: '100%',
            maxWidth: '100vw',
            background: 'transparent',
          }}
        >
          <NavBar />
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/login" component={ChooseLoginPage} />
            <Route exact path="/sign-up" component={ChooseSignup} />
            <Route exact path="/creative/login" component={LoginPage} />
            <Route exact path="/brand/login" component={BrandLoginPage} />
            <Route exact path="/brand/start-discovery" component={StartDiscovery} />
            {/* <Route exact path="/brand/discovery" component={BrandFlowPage} /> */}
            <Route exact path="/brand/home" component={BrandHome} />
            <Route exact path="/creative/signup" component={SignUpPage} />
            <Route exact path="/brand/signup" component={signupBrand} />
            <Route exact path="/creative/profile" component={ProfilePage} />
            <Route exact path="/admin/dashboard" component={AdminDashboardPage} />
            <Route exact path="/brand/profile" component={brandProfile} />
            <Route exact path="/jobs" component={JobsPage} />

            <Route exact path="/creative/home" component={Home} />
            <PrivateRoute
              exact
              path="/admin/dashboard"
              role={['Admin']}
              component={AdminDashboardPage}
            />

            <Route
              path="/on-boarding-flow/:step"
              render={() => {
                return (
                  <div>
                    <OnBoardingFlowStep />
                    <OnBoardingFlowPage />
                  </div>
                );
              }}
            />
            <Route
              path="/brand/discovery/:step"
              render={() => {
                return (
                  <div>
                    <DiscoverySteps />
                    <BrandFlowPage />
                  </div>
                );
              }}
            />
            <Route path="*" component={NotFoundPage} />
          </Switch>
          <Footer />
        </Layout.Content>
      </Layout>
    );
  }
}

export default Index;
